import { Component, Input } from '@angular/core';
import { InputModule } from "../input.module";
import { PublicBusiness } from "../../../../../../../api/src/business/business.entity";
import { BaseInputComponent } from "../base-input/base-input.component";
import { AsyncPipe, JsonPipe, NgIf } from "@angular/common";
import { delay, Observable, of, switchMap, take, map } from "rxjs";
import { SessionQuery } from "../../../../_core/state/session";
import { BusinessQuery, BusinessService } from "../../../../_core/state/business";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
	selector: 'app-business-selection-input',
	standalone: true,
	imports: [
		InputModule,
		NgIf,
		AsyncPipe,
		JsonPipe,
		MatProgressSpinnerModule
	],
	templateUrl: './business-selection-input.component.html',
	styleUrl: './business-selection-input.component.scss'
})
export class BusinessSelectionInputComponent extends BaseInputComponent {
	@Input() selectedBusinesses: string[] | null = null;
	@Input() showAllBusinesses: boolean = false;
	@Input() multiple: boolean = false;

	public businesses$: Observable<PublicBusiness[]>;

	constructor(
		private readonly sessionQuery: SessionQuery,
		private readonly businessQuery: BusinessQuery,
		private readonly businessService: BusinessService,
	) {
		super();

		const isSuperAdmin = this.sessionQuery.isAtLeastSuperAdmin();
		this.businesses$ = of(isSuperAdmin).pipe(
			take(1),
			// First, load all businesses if super admin
			switchMap(isAdmin => {
				if (isAdmin) {
					// Load all businesses and wait for completion
					return this.businessService.loadAllBusinesses().pipe(
						// After loading, emit the admin status
						map(() => isAdmin),
						// Small delay to ensure store is updated
						delay(100)
					);
				}
				return of(isAdmin);
			}),

			// Then, get the filtered business list from the store
			switchMap(isAdmin => {
				if (isAdmin) {
					// Super admins get all businesses from the store
					const allBusinesses = this.businessQuery.getAll();
					return of(allBusinesses);
				} else {
					// Regular users get their businesses from profile
					return this.sessionQuery.profile$.pipe(
						map(profile => {
							console.log('profile businesses', profile?.businesses);
							return profile?.businesses ?? [];
						})
					);
				}
			}),
			// Filter out the "ALL" option if it exists
			map(businesses => businesses.filter(business => business.id !== 'ALL'))
		);
	}

	changeValue(value: any): void {
		this.selectedBusinesses = value;
		this.form.patchValue({ [this.controlName]: value });
	}
}
